// DEV hot reload of shared/data (loaderDev.ts emits; the app subscribes). Lives in its own module so the
// listener list survives loaderDev.ts being re-executed by HMR.
import type { GameData } from './gameData.ts';

type Listener = (data: GameData) => void;
const listeners: Listener[] = [];

/** Subscribes to DEV data reloads (M5: GameController.reloadDefs). Returns the unsubscribe function. */
export function onDataReload(fn: Listener): () => void {
  listeners.push(fn);
  return () => {
    const i = listeners.indexOf(fn);
    if (i >= 0) listeners.splice(i, 1);
  };
}

export function emitDataReload(data: GameData): void {
  for (const fn of [...listeners]) fn(data);
}
